import { render, staticRenderFns } from "./ApprovalPopup.vue?vue&type=template&id=03074e2b&scoped=true&"
import script from "./ApprovalPopup.vue?vue&type=script&lang=js&"
export * from "./ApprovalPopup.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalPopup.vue?vue&type=style&index=0&id=03074e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03074e2b",
  null
  
)

export default component.exports